import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { formatSessionTime } from '../utils/formatters';
import './GNB.css';

function GNB({ currentView }) {
  const navigate = useNavigate();
  const { 
    user, 
    logout, 
    sessionTimeLeft, 
    extendSession, 
    showSessionPopup, 
    closeSessionPopup, 
    isExtendingSession 
  } = useAuth();

  const menuItems = [
    {
      id: 'notice',
      label: '공지사항',
      icon: '📢',
      className: 'btn btn-secondary',
      visible: true
    },
    {
      id: 'insights',
      label: '기업',
      icon: '🏢',
      className: 'btn btn-primary',
      visible: true
    },
    {
      id: 'payroll',
      label: '임금대장',
      icon: '🧮',
      className: 'btn btn-success',
      visible: true
    },
    {
      id: 'retirement',
      label: '퇴직정산',
      icon: '💰',
      className: 'btn btn-info',
      visible: true
    },
    {
      id: 'extras',
      label: '추가 기능',
      icon: '🧩',
      className: 'btn btn-secondary',
      visible: true
    },
    {
      id: 'profile',
      label: '내 정보',
      icon: '👤',
      className: 'btn btn-primary',
      visible: true
    },
    {
      id: 'admin',
      label: '관리자 메뉴',
      icon: '⚙️',
      className: 'btn btn-warning',
      visible: user && user.level === '관리자'
    }
  ];

  const handleExtendSession = async () => {
    const result = await extendSession();
    if (!result.success) {
      alert(result.error || '세션 연장에 실패했습니다.');
    }
  };

  const handlePopupLogout = () => {
    closeSessionPopup();
    logout();
  };

  const handleMenuClick = (viewId) => {
    // URL 경로 매핑
    const pathMap = {
      'payroll': '/payroll',
      'insights': '/insights',
      'retirement': '/retirement',
      'extras': '/extras',
      'notice': '/notice',
      'profile': '/profile',
      'admin': '/admin'
    };
    
    const path = pathMap[viewId] || '/payroll';
    navigate(path);
  };

  return (
    <>
      <header className="gnb">
        <div className="gnb-brand">
          <h1>도안 브릿지</h1>
        </div>
        
        <nav className="gnb-menu">
          {menuItems.map(item => {
            if (!item.visible) return null;

            return (
              <button
                key={item.id}
                onClick={() => handleMenuClick(item.id)}
                className={`${item.className} gnb-menu-item ${currentView === item.id ? 'active' : ''}`}
                title={item.label}
              >
                <span className="menu-icon">{item.icon}</span>
                <span className="menu-label">{item.label}</span>
              </button>
            );
          })}
        </nav>
        
        <div className="gnb-user-info">
          <span className="user-welcome">{user?.name || user?.id}님 환영합니다</span>
          
          {sessionTimeLeft && (
            <>
              <span className="session-label">
                남은 시간: {formatSessionTime(sessionTimeLeft)}
              </span>
              <button 
                onClick={handleExtendSession} 
                className="extend-session-btn"
                title="세션 연장"
                disabled={isExtendingSession}
              >
                {isExtendingSession ? '연장 중...' : '연장'}
              </button>
            </>
          )}
          
          <button onClick={logout} className="btn btn-danger btn-sm">
            로그아웃
          </button>
        </div>
      </header>

      {/* 세션 만료 팝업 */}
      {showSessionPopup && (
        <div className="session-popup-overlay">
          <div className="session-popup">
            <div className="session-popup-header">
              <h3>세션 만료 경고</h3>
            </div>
            <div className="session-popup-content">
              <p>세션이 곧 만료됩니다. ({formatSessionTime(sessionTimeLeft)} 남음)</p>
              <p>세션을 연장하시겠습니까?</p>
            </div>
            <div className="session-popup-actions">
              <button 
                onClick={handleExtendSession}
                className="session-extend-btn"
                disabled={isExtendingSession}
              >
                {isExtendingSession ? '연장 중...' : '연장하기'}
              </button>
              <button 
                onClick={handlePopupLogout}
                className="session-logout-btn"
              >
                로그아웃
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default GNB;
